import http from './http';

export async function listClientSubscriptions(clientId) {
  if (!clientId) return [];

  const res = await http.get(`/billing/client/${clientId}/subscriptions`);
  return res.data?.data ?? res.data ?? [];
}

